<mat-toolbar-row>
  <a mat-icon-button (click)="close()"><img src="assets/icons/icon-close.svg" alt="close"/></a>
  <h3>{{title}}</h3>
</mat-toolbar-row>
